var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79934 3.80032C5.11214 2.48752 6.89268 1.75 8.74926 1.75C10.6058 1.75 12.3864 2.48752 13.6992 3.80032C15.012 5.11312 15.7495 6.89366 15.7495 8.75023C15.7495 10.3551 15.1984 11.9031 14.201 13.1413L18.03 16.9703C18.3229 17.2632 18.3229 17.7381 18.03 18.031C17.7371 18.3239 17.2622 18.3239 16.9693 18.031L13.1404 14.202C11.9021 15.1994 10.3541 15.7505 8.74926 15.7505C6.89268 15.7505 5.11214 15.0129 3.79934 13.7001C2.48655 12.3873 1.74902 10.6068 1.74902 8.75023C1.74902 6.89366 2.48655 5.11312 3.79934 3.80032ZM8.74926 3.25C7.29051 3.25 5.8915 3.82949 4.86 4.86098C3.82851 5.89248 3.24902 7.29148 3.24902 8.75023C3.24902 10.209 3.82851 11.608 4.86 12.6395C5.8915 13.671 7.2905 14.2505 8.74926 14.2505C10.208 14.2505 11.607 13.671 12.6385 12.6395C13.67 11.608 14.2495 10.209 14.2495 8.75023C14.2495 7.29148 13.67 5.89248 12.6385 4.86098C11.607 3.82949 10.208 3.25 8.74926 3.25Z",
    fill: "#CDCED6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.f467345c9bfc545822db2709745f09fc.svg";
export { ForwardRef as ReactComponent };